import React from 'react';
import { ArrowLeft, FileText } from 'lucide-react';
import { companyInfo } from '../data/companyInfo';

interface TermsConditionsPageProps {
  onNavigate: (path: string) => void;
}

export const TermsConditionsPage: React.FC<TermsConditionsPageProps> = ({ onNavigate }) => {
  return (
    <div className="bg-[#071426] text-[#D5DFEC] py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        
        <button
          onClick={() => onNavigate('/')}
          className="inline-flex items-center gap-2 text-xs font-semibold text-[#8FA0B8] hover:text-white transition-colors"
        >
          <ArrowLeft size={14} />
          <span>Back to Home</span>
        </button>

        <div className="space-y-3">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#0B2342] text-xs font-semibold uppercase tracking-wider text-[#FF851B]">
            <FileText size={14} />
            <span>TERMS OF ENGAGEMENT</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-white font-display">
            Terms & Conditions
          </h1>
          <p className="text-xs text-[#8FA0B8]">Last updated: October 2025</p>
        </div>

        <div className="p-8 rounded-2xl bg-[#0c1a2d] border border-[#1b2f4a] space-y-6 text-sm leading-relaxed text-[#D5DFEC]">
          <section className="space-y-2">
            <h2 className="text-lg font-bold text-white">1. Agreement to Terms</h2>
            <p>
              By accessing the website of {companyInfo.name} or contracting our software development, artificial intelligence, ERP, mobile application, or digital growth services, you agree to be bound by these Terms & Conditions.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-white">2. Scope of Services & Statements of Work</h2>
            <p>
              All software engineering, consulting, and digital marketing services are delivered pursuant to formal Statements of Work (SOW) or Master Services Agreements (MSA) executed between {companyInfo.name} and the client organization.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-white">3. Intellectual Property Rights</h2>
            <p>
              Unless explicitly specified otherwise in writing, upon receipt of full milestone payments, the client retains 100% ownership of custom source code, proprietary algorithms, database schemas, and custom visual assets developed specifically for their project.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-white">4. Warranties & SLA Support</h2>
            <p>
              We warrant that all delivered code will perform in material accordance with agreed technical specifications. Specific service level agreements (SLAs), bug-fix warranties, and hosting uptimes are defined in individual project schedules.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-white">5. Governing Law</h2>
            <p>
              These Terms and any dispute arising under them shall be governed by and construed in accordance with applicable laws, subject to mutual good-faith arbitration and resolution.
            </p>
          </section>
        </div>

      </div>
    </div>
  );
};
